
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { cn } from "@/lib/utils";

interface CardPerspectiveToggleProps {
  enabled: boolean;
  onChange: (checked: boolean) => void;
}

export const CardPerspectiveToggle = ({ enabled, onChange }: CardPerspectiveToggleProps) => {
  return (
    <div className="space-y-2">
      <Label className="text-sm font-medium flex items-center justify-between">
        <span>Efeito 3D</span>
        <Switch 
          checked={enabled}
          onCheckedChange={onChange}
        />
      </Label>
      <div className="h-16 flex items-center justify-center border rounded-md">
        <div 
          className={cn(
            "w-20 h-10 bg-card border border-muted-foreground/20 rounded shadow-sm flex items-center justify-center text-[8px]",
            enabled ? "transform rotate-y-3 perspective-500" : ""
          )}
          style={{
            transform: enabled ? "perspective(500px) rotateY(15deg)" : "",
            transition: "transform 0.3s ease"
          }}
        >
          Visualização
        </div>
      </div>
    </div>
  );
};
